module.exports = __webpack_public_path__ + "static/media/gemma_thumb.15c60abe.webp";